/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SendSmsRequest
 */
export interface SendSmsRequest {
    /**
     * 
     * @type {string}
     * @memberof SendSmsRequest
     */
    recipientNumber: string;
    /**
     * 
     * @type {string}
     * @memberof SendSmsRequest
     */
    messageContent: string;
    /**
     * 
     * @type {string}
     * @memberof SendSmsRequest
     */
    originTimeZoneId: string;
}

/**
 * Check if a given object implements the SendSmsRequest interface.
 */
export function instanceOfSendSmsRequest(value: object): value is SendSmsRequest {
    if (!('recipientNumber' in value) || value['recipientNumber'] === undefined) return false;
    if (!('messageContent' in value) || value['messageContent'] === undefined) return false;
    if (!('originTimeZoneId' in value) || value['originTimeZoneId'] === undefined) return false;
    return true;
}

export function SendSmsRequestFromJSON(json: any): SendSmsRequest {
    return SendSmsRequestFromJSONTyped(json, false);
}

export function SendSmsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendSmsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'recipientNumber': json['recipientNumber'],
        'messageContent': json['messageContent'],
        'originTimeZoneId': json['originTimeZoneId'],
    };
}

export function SendSmsRequestToJSON(json: any): SendSmsRequest {
    return SendSmsRequestToJSONTyped(json, false);
}

export function SendSmsRequestToJSONTyped(value?: SendSmsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'recipientNumber': value['recipientNumber'],
        'messageContent': value['messageContent'],
        'originTimeZoneId': value['originTimeZoneId'],
    };
}

